import Top from '../../component/top/Top';
import History from '../../component/history/History';
import Strong from '../../component/strong/Strong';
import Financially from '../../component/financially/Financially';
import ContactBox from '../../component/enquiry/ContactBox';
import { Helmet } from 'react-helmet';

const AboutUs = () => {
  return (
    <>
      <Helmet>
        <title>Top 10 Solar Module Manufacturer</title>
        <meta name="description" content="As a Top 10 Solar Module Manufacturer in India, Gautam Solar offers a wide range of premium solar panels designed for maximum efficiency and long-term durability. With cutting-edge R&D and state-of-the-art production facilities, Gautam Solar’s modules meet global quality standards and deliver exceptional output even in challenging weather conditions." />

        <meta name="keywords" content="Top 10 Solar Module Manufacturer, top Solar Energy company in india, best Solar Module Manufacturer company, solar panel companies, solar panel for home" />

        <link rel="canonical" href="https://gautamsolar.com/aboutus/" />
      </Helmet>

      <h1 className="sr-only">Strong Top Management</h1>
      <Top />
      <History />
      <Strong />
      <Financially />
      <ContactBox />
    </>
  );
};

export default AboutUs;